import _get from 'lodash/get';
import { DeliveryInputObject, QrCodeFileLayoutEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { SelectOption } from '@lib/components/Select/types';
import {
  FieldNames as GetQrCodeFormFieldNames,
  FormType,
} from 'components/GetQrCodeForm/types';

export default function getPreparedQrCodeDataFromValues(
  values: Values,
  ids: string[],
) {
  const formType = _get(
    values,
    `${GetQrCodeFormFieldNames.formType}.value`,
  ) as string;
  const fileFormat = _get(
    values,
    `${GetQrCodeFormFieldNames.fileFormat}.value`,
  ) as string;
  const fileFormatArray = fileFormat.split('.');
  const pageSize = _get(values, `${GetQrCodeFormFieldNames.pageSize}.value`);
  const recipients = _get(
    values,
    GetQrCodeFormFieldNames.recipientIds,
    [],
  ) as SelectOption[];
  const message = _get(values, GetQrCodeFormFieldNames.message) as
    string | null;
  const delivery: DeliveryInputObject | undefined =
    formType === FormType.email
      ? {
          recipientIds: recipients.map(({ value }) => String(value)),
          message: message || undefined,
        }
      : undefined;
  return {
    params: {
      fileFormat: fileFormatArray[0],
      fileLayout: fileFormatArray[1] || QrCodeFileLayoutEnum.SingleFile,
      ids,
      pageSize,
    },
    delivery,
  };
}
